import { render, staticRenderFns } from "./CompanyTransactions.vue?vue&type=template&id=0a43473a&scoped=true&"
import script from "./CompanyTransactions.vue?vue&type=script&lang=js&"
export * from "./CompanyTransactions.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTransactions.vue?vue&type=style&index=0&id=0a43473a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a43473a",
  null
  
)

export default component.exports